import type { NavigationTabOption } from '../@types';
import { JackpotProduct } from '../@types/api';
import type { ApiService } from '../utils/api';

export const JACKPOT_TABS = [
  { label: 'Sportsbook', value: 'sportsbook', requireSportsbook: true },
  { label: 'Casino', value: 'casino', requireCasino: true, casinoConfigFlag: 'jackpotEnabled' },
] satisfies NavigationTabOption[];

export const JACKPOT_API_SERVICE: Record<JackpotProduct, ApiService | undefined> = {
  sportsbook: undefined,
  casino: 'wallet',
};

export const JACKPOT_PRODUCT_OPTIONS = [
  {
    id: 'sportsbook',
    name: 'Sportsbook',
  },
  {
    id: 'casino',
    name: 'Casino',
  },
];

export const JACKPOT_TYPE_OPTIONS = [{ id: 'progressive', name: 'Progressive' }];
